import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import styles from './GwpPopups.module.css';
import { selectVariant } from '../../../selectors/productsSelectors';
import withSelectedCategoryId from '../../../HOC/withSelectedCategoryId/withSelectedCategoryId';

const GwpPopupsContentWrapper = (props) => {
  const {
    title,
    description,
    requestRemoveFromCart,
    hideSponsoredWarning,
    variantToRemove,
    selectedCategoryId,
  } = props;
  const categoryId = selectedCategoryId || 'All';

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.description}>{description}</p>
      <div className={styles.buttonsContainer}>
        <button
          type="button"
          className={styles.removeButton}
          onClick={() =>
            requestRemoveFromCart(
              variantToRemove.id,
              variantToRemove.parentId,
              null,
              null,
              categoryId
            )
          }
        >
          YES, REMOVE
        </button>
        <button
          type="button"
          className={styles.cancelButton}
          onClick={hideSponsoredWarning}
        >
          CANCEL
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const variantId = state.productsState.variantToRemove;

  return {
    variantToRemove: {
      ...selectVariant(state, { variantId }),
      id: variantId,
    },
  };
};

export default compose(
  withSelectedCategoryId,
  connect(mapStateToProps)
)(GwpPopupsContentWrapper);
